const selectors = {
  customerAddresses: '[data-customer-addresses]',
  customerForms: '[data-customer-login], [data-customer-register]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
  updateAddressButton: 'button[data-update], button[data-add]',
  submitButton: 'button[data-login], button[data-recover], button[data-register]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

class Customer {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();

    this.params = (new URL(document.location)).searchParams;
    this.username = this.params.get('login_username') || this.params.get('LOGIN_USERNAME');
    this.password = this.params.get('login_password') || this.params.get('LOGIN_PASSWORD');

    if(this.username && this.username != '' && this.password && this.password != '') {
      this._openCatalogLogin();
    }
  }

  _getElements() {
    const container = document.querySelectorAll(selectors.customerForms)[0];

    return container ? {
      container,
      submitButtons: container.querySelectorAll(selectors.submitButton),
    } : {};
  }

  _setupEventListeners() {
    this.elements.submitButtons.forEach((element) => {
      element.addEventListener('click', this._handleUpdateButtonClick);
    });
  }

  _handleUpdateButtonClick = ({ currentTarget }) => {
    currentTarget.setAttribute('aria-disabled', true);
    currentTarget.classList.add('loading');
    currentTarget.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  _openCatalogLogin() {
    const form = document.getElementById('customer_login');
    if(!form) { return };

    const hookUrl = this.params.get('hook_url') || this.params.get('HOOK_URL');
    const redirection_path = this.params.get('redirection_path') || this.params.get('REDIRECTION_PATH');
    //const redirection_path= "/pages/ociredirect?hook_url=" + encodeURIComponent(hookUrl);
    if(hookUrl) {
      document.cookie = `hook_url=${hookUrl}; path=/`;
    }

    form.querySelector('#CustomerEmail').value = this.username;
    form.querySelector('#CustomerPassword').value = this.password;

    if(redirection_path) {
      const returnToElement = document.createElement('input');
      returnToElement.value = redirection_path;
      returnToElement.setAttribute('type', 'hidden');
      returnToElement.setAttribute('name', 'return_to');
      form.append(returnToElement);
    }

    form.querySelector('button[data-login]').setAttribute('aria-disabled', true);
    form.querySelector('button[data-login]').classList.add('loading');
    form.submit();
  }
}
class CustomerAddresses extends Customer {
  constructor() {
    super();
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
      updateButtons: container.querySelectorAll(selectors.updateAddressButton),
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
    this.elements.updateButtons.forEach((element) => {
      element.addEventListener('click', this._handleUpdateButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    );
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}